require('./css/material-icons.css')
require('angular-material/angular-material.min.css')
require('leaflet/dist/leaflet.css')
require('leaflet-search/dist/leaflet-search.min.css')
require('leaflet-search/dist/leaflet-search.mobile.min.css')
require('./css/material.indigo-blue.css')
require('./css/style.css')
require('./css/style-v2.css')
require('./css/dynamic-css.css')
require('flag-icon-css/css/flag-icon.css')
require('./css/angular-data-grid.material.css')
require('c3-angular/examples/assets/css/c3.min.css')
require('leaflet-draw-toolbar/dist/leaflet.draw-toolbar.css')
require('leaflet-draw/dist/leaflet.draw.css')
require('./css/mdDateTimePicker/css/mdDateTimePicker.min.css')
require('./css/dashcamLiveVideo.css')
require('simplebar/src/simplebar.css')
require('ng-table/bundles/ng-table.css')
require('./css/slider.css')
